import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { ApplicationHostTypeService, HistoryService } from 'rome-library';
import { Observable } from 'rxjs';
import { TokenStore } from './../services/token.store';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationGuard implements CanActivate {
  constructor(
    private readonly tokenStore: TokenStore,
    private readonly router: Router,
    private readonly historyService: HistoryService,
    private readonly applicationHostTypeService: ApplicationHostTypeService
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (this.tokenStore.getUserContext().AccessToken && this.tokenStore.getUserContext().AccessTokenGuid) {
      return true;
    }

    this.historyService.initialRedirectUrl = state.url;
    void this.router.navigate(['/', this.applicationHostTypeService.getCode(), 'login']);

    return false;
  }
}
